import { Controller } from 'lib_ts/enums/routing/controllers';
import { ServerErrorsRoutes } from 'lib_ts/enums/routing/routes/server-errors';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import {
  IServerError,
  IServerErrorSummary,
} from 'lib_ts/interfaces/i-server-error';
import { BaseRESTService } from 'services/_base-rest.service';

export class ServerErrorsService extends BaseRESTService {
  private static instance: ServerErrorsService;
  static getInstance(): ServerErrorsService {
    if (!ServerErrorsService.instance) {
      ServerErrorsService.instance = new ServerErrorsService();
    }

    return ServerErrorsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.ServerErrors,
    });
  }

  async getSummaries(): Promise<IServerErrorSummary[]> {
    return await this.get({
      uri: ServerErrorsRoutes.GetSummaries,
    }).then((result: IServerResponse) => result.data as IServerErrorSummary[]);
  }

  async getById(id: string): Promise<IServerError> {
    return await this.get({
      uri: `${ServerErrorsRoutes.GetOne}/${id}`,
    }).then((result: IServerResponse) => result.data as IServerError);
  }
}
